/** Tunable public-search performance knobs — change here only. */
export const QUICK_SEARCH_MIN_LENGTH = 2;

/** Hero search, progeny ident filter, basic-dialog preview count. */
export const QUICK_SEARCH_DEBOUNCE_MS = 500;

/** Chip multiselect typeahead (faster than hero search). */
export const QUICK_SEARCH_TYPEAHEAD_DEBOUNCE_MS = 250;

export const QUICK_SEARCH_TOP_RESULTS = 10;
